import React, { useState, useEffect } from 'react';

const DelayRender = (WrappedComponent, delay = 300) => {
  return function DelayedComponent(props) {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, delay);

      return () => clearTimeout(timer);
    }, []);

    if (isLoading) {
      return (
        <div className="page">
          <div className="page-container spinner-container">
            <div className="spinner"></div>
          </div>
        </div>
      );
    }

    return <WrappedComponent {...props} />;
  };
};

export default DelayRender;